export default "__VITE_PUBLIC_ASSET__e017e1f6__"